import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "disabled", "hasError", "checked", "className", "inputClassName", "hoverBackground", "isOnHover", "withBorder", "radioOnTheRight", "secondaryLabel"];
import React from 'react';
import { Label, LeftRadioLabel, RadioIndicator, RadioInput, RadioLabel, RadioLabelColumn, RightRadioLabel, SecondaryLabel } from "./Radio.styles.js";
export var Radio = function Radio(_ref) {
  var label = _ref.label,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    checked = _ref.checked,
    className = _ref.className,
    inputClassName = _ref.inputClassName,
    _ref$hoverBackground = _ref.hoverBackground,
    hoverBackground = _ref$hoverBackground === void 0 ? true : _ref$hoverBackground,
    isOnHover = _ref.isOnHover,
    withBorder = _ref.withBorder,
    radioOnTheRight = _ref.radioOnTheRight,
    secondaryLabel = _ref.secondaryLabel,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isHoverControlled = isOnHover !== undefined;
  var _React$useState = React.useState(isHoverControlled ? isOnHover : false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHovered = _React$useState2[0],
    setIsHovered = _React$useState2[1];
  var onMouseEnter = function onMouseEnter() {
    setIsHovered(true);
  };
  var onMouseLeave = function onMouseLeave() {
    setIsHovered(false);
  };
  var hoveringProps = !isHoverControlled ? {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  } : undefined;
  var computedIsHovered = isHoverControlled ? isOnHover : isHovered;
  return /*#__PURE__*/React.createElement(Label, _extends({}, hoveringProps, {
    $disabled: !!disabled,
    $hoverBackground: hoverBackground,
    "data-testid": "radio",
    className: className,
    $isHovered: !!computedIsHovered,
    $withBorder: withBorder,
    $hasError: hasError
  }), radioOnTheRight && label !== undefined && (secondaryLabel ? /*#__PURE__*/React.createElement(RadioLabelColumn, {
    $radioOnTheRight: true,
    "data-testid": "radio-label"
  }, /*#__PURE__*/React.createElement(RadioLabel, {
    $disabled: disabled
  }, label), /*#__PURE__*/React.createElement(SecondaryLabel, {
    $disabled: disabled
  }, secondaryLabel)) : /*#__PURE__*/React.createElement(RightRadioLabel, {
    "data-testid": "radio-label",
    $disabled: disabled
  }, label)), /*#__PURE__*/React.createElement(RadioInput, _extends({
    "data-testid": "radio-input",
    className: inputClassName
  }, otherProps, {
    disabled: disabled,
    checked: checked,
    $hasError: hasError,
    type: "radio"
  })), /*#__PURE__*/React.createElement(RadioIndicator, {
    $disabled: disabled,
    $hasError: hasError,
    "data-testid": "radio-indicator",
    "aria-hidden": "true"
  }), !radioOnTheRight && label !== undefined && (secondaryLabel ? /*#__PURE__*/React.createElement(RadioLabelColumn, {
    "data-testid": "radio-label"
  }, /*#__PURE__*/React.createElement(RadioLabel, {
    $disabled: disabled
  }, label), /*#__PURE__*/React.createElement(SecondaryLabel, {
    $disabled: disabled
  }, secondaryLabel)) : /*#__PURE__*/React.createElement(LeftRadioLabel, {
    "data-testid": "radio-label",
    $disabled: disabled
  }, label)));
};